/*@ngInject*/
const ConfiguredFileDataRepository = function (baseCachedRepository) {

    angular.extend(this, baseCachedRepository);

    this.getCacheName = function () {
        return 'configuredFileDataCache';
    };

    this.getCacheCapacity = function () {
        return 50;
    };

    this.getData = function (id) {
        const url = `/rest/ConfiguredFile/${id}/data`,
            cacheKey = 'configuredFileData-' + id;

        return this.get(cacheKey, url);
    };
};

angular.module('umCore')
    .service('configuredFileDataRepository', ConfiguredFileDataRepository);
